import React from 'react';
import { TDR } from 'tdr-common';
import { InfoDialog } from './InfoDialog';
import { DepositIcon } from '../../icons';
import { CancellationPolicy } from './CancellationPolicy';
import { useTranslation } from 'react-i18next';

type DepositInfoProps = {
	restaurant: TDR.Restaurant;
	invoice: TDR.Invoice;
};

export const DepositInfo = ({ restaurant, invoice }: DepositInfoProps) => {
	const { t } = useTranslation();
	const cancelCutoff = (restaurant.reservationCutoffs.find((cutoff) => !!cutoff.cancel)?.cancel?.time || 24) + ' hours';

	return (
		<InfoDialog
			variant='feedback'
			title={t('titles.deposit')}
			triggerButton={<DepositIcon />}
			body={
				<>
					<p>
						{t('checkout.modals.deposit.description1')}
					</p>
					<p>
						{t('checkout.modals.deposit.description2')}{' '}
						<CancellationPolicy restaurant={restaurant} cancelCutoff={cancelCutoff} invoice={invoice} />
					</p>
				</>
			}
		/>
	);
};
